module.exports = __webpack_public_path__ + "static/media/angajari-asia-min.0696b221.webp";